import { PlaybackTriggerEnum } from '@setplex/tria-api'

export { PlaybackTriggerEnum }

// TODO: all values should be added/redo step by step according docs
// use interpolate if needed
export const OPEN_FROM = {
  BANNERS: 'Banners',
  HOME: 'Home',
  BROWSE: 'Browse',
  RECOMMENDED: 'Recommended',
  FAVORITES: 'Favorites',
  CREATOR: 'Creator page',
  SEARCH: 'Search results',
  SEARCH_CREATOR_LATEST_CONTENT: 'Search creators latest content',
  DIRECT_LINK: 'Direct link',
  LIVE: 'Live',
  MOVIES: 'Movies/{category_name}/{language_name}',
  TVSHOWS: 'TVShows/{category_name}/{language_name}',
}

export enum CategoryIdHumanized {
  All = 'ALL',
  Favorite = 'MYLIST',
}

export enum AnalyticsProgramTitle {
  /** play_start, play_stop, player_watching, player_event — event_parameter13 */
  HOURLY_CATCHUP = '',
  /** epg_program, live without program title — event_parameter7 */
  NO_EPG_DATA = 'No EPG data',
  /** epg_program — event_parameter7 */
  HOURLY_CATCHUP_EPG = 'hourly',
}
